import { render, staticRenderFns } from "./MonthlyEISMaybank.vue?vue&type=template&id=0bc3c942&scoped=true"
import script from "./MonthlyEISMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlyEISMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc3c942",
  null
  
)

export default component.exports